import React from 'react';
import {
  Box,
  Typography,
  TableCell,
  Button,
  Tooltip,
  Zoom,
} from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DownloadIcon from '@mui/icons-material/Download';
import { ApiService } from 'app/servicesTwo/ApiService';
import { capitalizeFLetter } from '@jumbo/utils';
import moment from 'moment';
import 'moment/locale/pt-br';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { GreatVibesRegular } from 'assets/fonts/GreatVibes-regular';

const ContinuingCoursesList = ({ coursesContinued, user }) => {
  moment.locale('pt-br');
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  window.pdfMake.vfs['GreatVibes-Regular.ttf'] = GreatVibesRegular;
  pdfMake.fonts = {
    Roboto: {
      normal:
        'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
      bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
      italics:
        'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
      bolditalics:
        'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf',
    },
    GreatVibes: {
      normal: 'GreatVibes-Regular.ttf',
      bold: 'GreatVibes-Regular.ttf',
      italics: 'GreatVibes-Regular.ttf',
      bolditalics: 'GreatVibes-Regular.ttf',
    },
  };

  const Swal = useSwalWrapper();
  const toast = (variant, message) => {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon: variant,
      title: message,
      showCloseButton: true,
      closeButtonAriaLabel: 'Fechar',
    });
  };

  const loadImageBase64 = (path) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        if (xhr.status === 200) {
          const reader = new FileReader();
          reader.onloadend = function () {
            const result = reader.result;
            // Validate that we have a proper dataURL
            if (
              result &&
              typeof result === 'string' &&
              result.startsWith('data:image/')
            ) {
              resolve(result);
            } else {
              console.warn(
                'Invalid image data for path:',
                path,
                'Result:',
                result?.substring(0, 50)
              );
              resolve(null);
            }
          };
          reader.onerror = function () {
            console.error('FileReader error for path:', path);
            resolve(null);
          };
          reader.readAsDataURL(xhr.response);
        } else {
          console.warn(
            'HTTP error loading image:',
            path,
            'Status:',
            xhr.status
          );
          resolve(null);
        }
      };
      xhr.onerror = function () {
        console.error('Network error loading image:', path);
        resolve(null);
      };
      xhr.open('GET', path);
      xhr.responseType = 'blob';
      xhr.send();
    });
  };

  const getDirectorForCertified = async (id, user, nomeDoCurso, curso) => {
    try {
      ApiService.get(`/diretores/curso-historico/${id}`)
        .then((response) => {
          gerarCertificado(user, response.data?.director, nomeDoCurso, curso);
        })
        .catch((error) => {
          if (error.response) {
            toast('error', error.response.data.error);
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('error', error.message);
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  const gerarCertificado = (pessoa, diretor, nomeDoCurso, curso) => {
    // Carrega todas as imagens em paralelo

    if (!diretor) {
      return toast(
        'error',
        'Diretoria não cadastrada para este curso. Entrar em contado com a Secretaria de Ensino: 011 3188-8383 r. 237'
      );
    }

    const signatureUrl =
      diretor?.assinatura && diretor.assinatura.trim() !== ''
        ? `${process.env.REACT_APP_API_KEY}/images/${diretor.assinatura}`
        : null;

    const areaImageUrl = diretor?.Area?.imagem_area
    ? `${process.env.REACT_APP_API_KEY}/images/${diretor.Area.imagem_area}`
    : null;

    console.log('Gerando certificado com diretor:', diretor);
    console.log('URL da assinatura:', signatureUrl);

    Promise.all([
      loadImageBase64('/images/certificado_moldura.png'), // Fundo
      loadImageBase64('/images/logositefeesp.png'), // Logo
      signatureUrl ? loadImageBase64(signatureUrl) : Promise.resolve(null), // Assinatura
      //loadImageBase64('/images/ICONE_AREA_ENSINO.png'),
      areaImageUrl
      ? loadImageBase64(areaImageUrl).catch(() => null)
      : Promise.resolve(null),
    ])
      .then(([backgroundBase64, logoBase64, assinaturaBase64, iconArea]) => {
        console.log('Imagens carregadas:', {
          background: backgroundBase64 ? 'OK' : 'NULL',
          logo: logoBase64 ? 'OK' : 'NULL',
          assinatura: assinaturaBase64 ? 'OK' : 'NULL',
          icon: iconArea ? 'OK' : 'NULL',
        });

        const timestamp = curso.createdAt;

        // Formatar o timestamp para o formato desejado (DD de MMMM de YYYY)
        const formattedDate = moment(timestamp).format(
          'DD [de] MMMM [de] YYYY'
        );

        const cargaHoraria = curso?.Turma?.Curso?.carga_horaria;
        const anoTurma = curso?.Turma?.ano;
        const areaObj = diretor?.Area;
        const areaName = areaObj?.nome || '';
        const areaPhone = areaObj?.telefone || '';
        const areaRamal = areaObj?.ramal || '';

        const texto = cargaHoraria
          ? `Com carga horária de: ${cargaHoraria}, em ${anoTurma}.`
          : 'Com carga horária de: -.';

        const docDefinition = {
          pageSize: 'A4',
          pageMargins: [60, 50, 60, 50],
          background: backgroundBase64
            ? [
                {
                  image: backgroundBase64,
                  width: 590,
                },
              ]
            : [],
          content: [
            {
              columns: [
                logoBase64
                  ? {
                      image: logoBase64,
                      width: 200,
                      alignment: 'left',
                      margin: [0, 0, 0, 10],
                    }
                  : { text: '', width: 200 },
                /*  {
                    text: 'ÁREA DE ENSINO',
                    alignment: 'right',
                    color: '#1473B9',
                    bold: true,
                    fontSize: 16,
                    margin: [0, 35, 0, 0],
                  }, */
                iconArea
                  ? {
                      image: iconArea,
                      width: 135,
                      //alignment: 'right',
                      margin: [135, 30, 0, 0],
                    }
                  : { text: '', width: 135 },
              ],
            },
            {
              stack: [
                {
                  text: 'CERTIFICADO',
                  style: 'header',
                  alignment: 'center',
                },
                {
                  text: [
                    {
                      text: 'Conferido a ',
                      style: 'content',
                      alignment: 'center',
                    },
                    {
                      text: `${pessoa.nome}, `,
                      style: 'content',
                      alignment: 'center',
                      bold: true,
                      font: 'GreatVibes',
                      fontSize: 28,
                    },
                    {
                      text: `CPF ${pessoa.cpf ?? '-'},`,
                      style: 'content',
                      alignment: 'center',
                    },
                    {
                      text: ' pela conclusão do curso: ',
                      style: 'content',
                      alignment: 'center',
                    },
                    {
                      text: `${nomeDoCurso}. `,
                      style: 'content',
                      alignment: 'center',
                      bold: true,
                    },
                    {
                      text: `${texto}`,
                      style: 'content',
                      alignment: 'center',
                    },
                  ],
                  margin: [0, 5, 0, 5],
                },

                {
                  alignment: 'center',
                  stack: [
                    assinaturaBase64
                      ? {
                          image: assinaturaBase64,
                          width: 150, // Largura da imagem da assinatura
                          height: 60,
                          absolutePosition: { x: 50, y: 280 },
                        }
                      : { text: '' },
                    {
                      text: '______________________________',
                      absolutePosition: { x: 50, y: 315 },
                    },
                    {
                      text: `${diretor?.User?.nome || 'Diretoria'}`,
                      bold: true,
                      absolutePosition: { x: 50, y: 330 },
                    },
                    {
                      text: `Direção da Área de ${capitalizeFLetter(
                        diretor?.Area?.nome.toLowerCase() || 'ensino'
                      )}`,
                      absolutePosition: { x: 50, y: 345 },
                    },
                  ],
                },
                /* {
                  text: `São Paulo. Emitido em ${new Date().toLocaleDateString(
                    'pt-BR'
                  )}, às ${new Date().toLocaleTimeString(
                    'pt-BR'
                  )}, via sistema. Dúvidas: entrar em contato com a área de Ensino pelo telefone 011 3188-8383 ramal 237`,
                  style: 'dataEmissao',
                  alignment: 'center',
                  absolutePosition: { x: 50, y: 365 },
                }, */
                {
                  text: `São Paulo. Emitido em ${new Date().toLocaleDateString(
                    'pt-BR'
                  )}, às ${new Date().toLocaleTimeString(
                    'pt-BR'
                  )}, via sistema.${
                    areaPhone
                      ? ` Dúvidas: entrar em contato com a área de ${capitalizeFLetter(
                          areaName.toLowerCase()
                        )} pelo telefone ${areaPhone}${
                          areaRamal ? ` ramal ${areaRamal}` : ''
                        }`
                      : ''
                  }`,
                  style: 'dataEmissao',
                  alignment: 'center',
                  absolutePosition: { x: 50, y: 365 },
                },
              ],
            },
          ],
          defaultStyle: {
            font: 'Roboto', // Define a fonte padrão como Roboto
          },
          styles: {
            header: {
              fontSize: 24,
              bold: true,
              margin: [0, 10, 0, 0],
              color: '#1473B9',
            },
            content: {
              fontSize: 18,
              margin: [0, 10, 0, 10],
            },
            dataEmissao: {
              fontSize: 10,
              italics: true,
              margin: [0, 40, 0, 0],
            },
          },
        };

        // Gera o PDF com o pdfMake
        pdfMake.createPdf(docDefinition).download('certificado.pdf');
      })
      .catch((error) => {
        console.error('Erro ao carregar as imagens:', error);
      });
  };

  const coursesContinuingFiltered = coursesContinued.filter(
    (item) => !item.curso_compativel_id
  );

  const sortedCoursesContinuingFiltered = coursesContinuingFiltered.sort(
    (a, b) => {
      const anoA = parseInt(a.Turma?.ano);
      const anoB = parseInt(b.Turma?.ano);

      if (anoA < anoB) {
        return -1;
      }
      if (anoA > anoB) {
        return 1;
      }
      return 0;
    }
  );

  const columnsContinuing = [
    {
      name: 'Turma.Curso.nome',
      label: 'Nome',
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          width: '40%',
        }),
        customHeadRender: (
          columnMeta,
          handleToggleColumn,
          sortOrder,
          sortColumn
        ) => <TableCell width={'40%'}>Nome</TableCell>,
      },
    },
    {
      name: 'ano_de_conclusao',
      label: 'Conclusão',
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: 'center',
        }),
        setCellProps: () => ({
          align: 'center',
        }),
        customBodyRender: (value) => (
          <Typography variant={'body1'}>{value ?? '-'}</Typography>
        ),
      },
    },
    {
      name: 'Turma',
      label: 'Local',
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: (value) => ({
          align: 'center',
          width: '25%',
        }),
        setCellProps: () => ({
          align: 'center',
          width: '25%',
        }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <>
            <Typography variant={'body1'}>
              {value?.Centro_Espirita?.nome_fantasia || value?.local}
            </Typography>
          </>
        ),
      },
    },
    {
      name: 'Turma.Curso.nome',
      label: 'Gerar Certificado',
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: 'center',
        }),
        setCellProps: () => ({
          align: 'center',
        }),
        customHeadRender: (
          columnMeta,
          handleToggleColumn,
          sortOrder,
          sortColumn
        ) => (
          <TableCell align='center'>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              Gerar Certificado
              <Box
                component='span'
                sx={{
                  fontSize: '0.7rem',
                  color: 'error.main',
                  fontWeight: 'bold',
                  lineHeight: 1,
                }}
              >
                (Somente após 2024)
              </Box>
            </Box>
          </TableCell>
        ),
        customBodyRender: (value, tableMeta) => {
          const courseData =
            sortedCoursesContinuingFiltered[tableMeta.rowIndex];

          if (courseData.ano_de_conclusao < 2024) return null;
          console.log({courseData})
          return (
            <Button
              disableElevation
              variant={'contained'}
              size={'small'}
              color={'info'}
              onClick={async () => {
                await getDirectorForCertified(
                  courseData.curso_historico_id,
                  user,
                  value,
                  courseData
                );
              }}
            >
              <Tooltip
                title='Gerar Certificado Individual'
                TransitionComponent={Zoom}
                arrow
              >
                <DownloadIcon />
              </Tooltip>
            </Button>
          );
        },
      },
    },
  ];

  const optionsContinuing = {
    pagination: false,
    filterType: 'checkbox',
    selectableRows: 'none',
    search: false,
    download: false,
    print: false,
    sortFilterList: false,
    viewColumns: false,
    filter: false,
    enableNestedDataAccess: '.',
    textLabels: {
      pagination: {
        next: 'Próxima Página',
        previous: 'Página Anterior',
        rowsPerPage: 'Itens por Página:',
        displayRows: 'de',
      },
    },
    setTableProps: () => {
      return {
        size: 'small',
      };
    },
  };

  const componentsContinuing = {
    ExpandButton: function (props) {
      return <div style={{ width: '24px' }} />;
    },
  };

  return (
    <Box
      display='flex'
      flexDirection='column'
      gap={1}
      marginTop='2rem'
      marginBottom='1rem'
    >
      <Typography variant={'h4'} margin={0} fontWeight={'bold'}>
        Cursos de Educação Continuada
      </Typography>
      {sortedCoursesContinuingFiltered.length > 0 ? (
        <MUIDataTable
          data={sortedCoursesContinuingFiltered}
          columns={columnsContinuing}
          options={optionsContinuing}
          components={componentsContinuing}
        />
      ) : (
        <Typography>Nenhum curso encontrado</Typography>
      )}
    </Box>
  );
};

export default ContinuingCoursesList;
